import { render } from "./AddressSearchComponent.vue?vue&type=template&id=539183e4&ts=true"
import script from "./AddressSearchComponent?vue&type=script&lang=ts"
export * from "./AddressSearchComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__